import { PromotionBanner } from '@fff-web/fff-ui-shared/PromotionBanner';
import { useBoxName } from '@fff-web/fff-payments';
import { useReactivatePlanDataContext } from '../../utils/ContextProviders/ReactivatePlanDataContext';
import { IPlanCode } from '../../utils/Interfaces';
import { useReactivateMyMembershipContext } from '../../utils/ContextProviders/ReactivateContext';
import { GROWTH_MY_REACTIVATE_MEMBERSHIP } from '../../utils/Optimizely/featureFlagVariations';

interface PromotionBannerContainerProps {
  onClick(): void;
}

const SEASONAL_PROMO_CODE = 'mygift';
const MYSTERY_LABEL = 'MYSTERY';
const NON_MYSTERY_LABEL = 'NON_MYSTERY';

interface GetDiscountMessageProps {
  discount: number;
  boxName: string;
}

export const getDiscountMessage = ({
  discount,
  boxName,
}: GetDiscountMessageProps) => {
  const discountFormatted = Math.abs(discount).toFixed(2);
  return `Yay! You're getting $${discountFormatted} off your ${boxName}. All discounts will be applied at checkout.`;
};

export const getMysteryMessage = (boxName: string) => {
  return `Yay! You're getting a FREE Mystery Gift with your ${boxName}. This offer will be applied at checkout.`;
};

export const getNoCouponMessage = (boxName: string) => {
  return `Hurry! Claim 20% off your ${boxName} when signing up for a Seasonal Membership.`;
};

const PromotionBannerContainer = ({
  onClick,
}: PromotionBannerContainerProps) => {
  const {
    growthMyMembership: { variationKey },
  } = useReactivateMyMembershipContext();

  const {
    couponData,
    discount,
    onPlanChange,
    selectedPlanCode,
    handleCallCouponApi,
    loading: isCouponLoading,
    handleOnChange: handleCouponChange,
  } = useReactivatePlanDataContext();

  const { boxName } = useBoxName();

  const isVariationJ =
    variationKey === GROWTH_MY_REACTIVATE_MEMBERSHIP.VARIATION_J;

  if (!isVariationJ || isCouponLoading) {
    return null;
  }

  const renderMessage = () => {
    const { couponType, previewDescription } = couponData;

    if (previewDescription) return previewDescription;

    if (couponType === MYSTERY_LABEL || couponType === NON_MYSTERY_LABEL) {
      return getMysteryMessage(boxName);
    }

    return getDiscountMessage({ discount: +discount, boxName });
  };

  const handleClick = () => {
    if (couponData) {
      onClick();
      return;
    }

    if (selectedPlanCode === IPlanCode.SEASONAL) {
      handleCallCouponApi(SEASONAL_PROMO_CODE);
    }

    if (selectedPlanCode === IPlanCode.ANNUAL) {
      handleCouponChange(null, SEASONAL_PROMO_CODE);
      onPlanChange(IPlanCode.SEASONAL);
    }

    onClick();
  };

  return (
    <PromotionBanner onClick={handleClick}>
      <p>{couponData ? renderMessage() : getNoCouponMessage(boxName)}</p>
    </PromotionBanner>
  );
};

export default PromotionBannerContainer;
